"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabs = void 0;
var camel_case_1 = require("camel-case");
var react_1 = require("react");
function useTabs(options) {
    var _a = options.initialSelected, initialSelected = _a === void 0 ? 0 : _a, labels = options.labels, numericIndicators = options.numericIndicators;
    var _b = (0, react_1.useState)(initialSelected || 0), activeIndex = _b[0], selectTab = _b[1];
    var formattedTabs = (0, react_1.useMemo)(function () {
        return labels.map(function (tab, index) {
            var slug = (0, camel_case_1.camelCase)(tab);
            var panelId = "tabpanel-".concat(slug);
            var data = {
                id: "tab-".concat(slug),
                panelId: panelId,
                label: tab,
                isActive: activeIndex === index,
            };
            if (numericIndicators === null || numericIndicators === void 0 ? void 0 : numericIndicators.length) {
                Object.assign(data, { numericIndicator: numericIndicators[index] });
            }
            return data;
        });
    }, [labels.join(''), numericIndicators, activeIndex]);
    return {
        tabs: formattedTabs,
        selectTab: selectTab,
        activeIndex: activeIndex,
    };
}
exports.useTabs = useTabs;
//# sourceMappingURL=hook.js.map